import { ALLOW_SERVICE_REQUESTS } from "../../actionTypes/service";

export function setAllowServiceRequests(allowServiceRequests: any) {
  return { type: ALLOW_SERVICE_REQUESTS, payload: allowServiceRequests };
}
